<template>
  <v-row dense v-if="pupillaryDistance">
    <v-col>
      <v-row>
        <v-col class="text-subtitle-2 gray--text text--lighten-1">
          Distância pupilar
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="auto">
          <v-row dense>
            <v-col class="font-weight-bold text-body-2">
              Olho direito
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              {{ pupillaryDistance.rightEye }}
            </v-col>
          </v-row>
        </v-col>

        <v-col>
          <v-row dense>
            <v-col class="font-weight-bold text-body-2">
              Olho esquerdo
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              {{ pupillaryDistance.leftEye }}
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: "GlassesPrescriptionPupillaryDistance",
    props: {
      pupillaryDistance: Object,
    },
  };
</script>

<style lang="scss" scoped></style>
